import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMozambique = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1502)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.48617 16.6956L3.51514 20.4849C5.68657 22.6566 8.68624 24 12 24C16.9608 24 21.2177 20.9893 23.0452 16.6956H6.48617Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.0639 7.3478C21.2466 3.03103 16.9776 0 12 0C8.68624 0 5.68657 1.34339 3.51514 3.51511L6.52029 7.3478H23.0639Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.6087 8.82608V15.1304H23.5867C23.8558 14.1324 24 13.0831 24 12C24 10.9011 23.852 9.83708 23.5753 8.82608H2.6087Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.51471 3.51468C-1.17157 8.20096 -1.17157 15.799 3.51471 20.4853C5.45126 18.5488 7.31374 16.6863 12 12L3.51471 3.51468Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.8567 8.86954L5.63366 11.2609H8.14832L6.11403 12.739L6.89094 15.1304L4.8567 13.6524L2.82237 15.1304L3.59947 12.739L1.56519 11.2609H4.07966L4.8567 8.86954Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.58313 12H7.13113V14.087H2.58313V12Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.99216 9.60744L7.2543 8.86954L4.85674 11.2671L2.45917 8.86954L1.72131 9.60744L4.12099 12.0029L1.72131 14.4026L2.45917 15.1304L4.85674 12.7372L7.2543 15.1304L7.99216 14.4026L5.59249 12.0029L7.99216 9.60744Z",
				fill: "black"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1502",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgMozambique;
